/* ==========================================================================
   Header menu — open dropdowns on hover

   Kidu's <dropdown-component> binds to `click` only (global.js ~line 1003),
   so a top-level menu item with children needs a deliberate tap to open. On a
   desktop pointer that reads as slow; the reference behaviour is to reveal the
   panel as soon as the cursor arrives.

   This does NOT call the component's own open()/close(). Its open() runs
   `this.content.focus()`, which on hover would pull focus — and the page
   scroll with it — every time the cursor crossed the nav. Instead the same
   two things open() sets are set directly: the `dropdown--open` class the CSS
   keys off, and `aria-expanded` on the opener. Clicking still works exactly as
   before, and because both paths write the same state they cannot disagree.

   Scope:
     - pointer: fine        excludes touch, where hover has no meaning and
                            would fire on the tap that should navigate
     - min-width: 992px     below this the nav is replaced by the side menu

   Listeners are attached once per element and guarded by a flag, and the media
   query is re-read inside the handlers rather than at bind time. Re-running
   bind() after a section reload is therefore idempotent.

   The panel is a descendant of the <li>, so moving the cursor down into it
   never leaves the element. The close delay only covers the gap between the
   button and the panel's top edge.
   ========================================================================== */

(function () {
  'use strict';

  var QUERY = '(min-width: 992px) and (pointer: fine)';
  var CLOSE_DELAY = 120;
  var FLAG = '__menuHoverBound';

  var mq = window.matchMedia(QUERY);

  function parts(item) {
    return {
      wrapper: item.querySelector('.dropdown-component_wrapper'),
      opener: item.querySelector('.dropdown-component_opener')
    };
  }

  function open(item) {
    if (!mq.matches) return;
    clearTimeout(item.__menuHoverTimer);
    var p = parts(item);
    if (!p.wrapper) return;
    p.wrapper.classList.add('dropdown--open');
    if (p.opener) p.opener.setAttribute('aria-expanded', 'true');
  }

  function close(item) {
    if (!mq.matches) return;
    clearTimeout(item.__menuHoverTimer);
    item.__menuHoverTimer = setTimeout(function () {
      var p = parts(item);
      if (!p.wrapper) return;
      p.wrapper.classList.remove('dropdown--open');
      if (p.opener) p.opener.setAttribute('aria-expanded', 'false');
    }, CLOSE_DELAY);
  }

  function bind() {
    var items = document.querySelectorAll('.main-navigation_item');

    items.forEach(function (item) {
      if (item[FLAG]) return;
      if (!item.querySelector('.dropdown-component_wrapper')) return;
      item[FLAG] = true;

      item.addEventListener('mouseenter', function () {
        open(item);
      });
      item.addEventListener('mouseleave', function () {
        close(item);
      });

      /* Keyboard users tab to the opener; revealing the panel on focus keeps
         them in step with what a mouse user sees. Kidu's click handler still
         toggles it, so Enter and Space behave as before. */
      item.addEventListener('focusin', function () {
        open(item);
      });
      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        close(item);
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(bind);

  /* The header is a section: the theme editor replaces its markup wholesale on
     every settings change, so the new nodes need binding. The flag lives on
     the element, which is discarded with it, so nothing is double-bound. */
  document.addEventListener('shopify:section:load', bind);
})();